<template>
  <div v-if="loaded">
    <h4 class="page-title">세무지식 수정</h4>

    <edit-knowhow-form />
  </div>
</template>
<script>
  import EditKnowhowForm from "@/components/announcement/notice/EditKnowhowForm";
  import {dispatch} from "@/core/dispatcher";
  import SelectAnnouncementJob from "@/core/jobs/announcement/SelectAnnouncementJob";

  export default {
    data() {
      return {
        loaded: false
      };
    },
    components: {
      EditKnowhowForm
    },
    mounted() {
      dispatch(new SelectAnnouncementJob(parseInt(this.$route.params.id))).then(() => {
        this.loaded = true;
      });
    }
  }
</script>
